import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, FrownIcon, HeartCrackIcon, HomeIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  const painPoints = [{
    icon: <FrownIcon className="w-6 h-6 text-red-500" data-id="element-154" />,
    text: 'Te duele ver que tu hijo ya no juega con ilusión, sino con miedo y presión'
  }, {
    icon: <TrendingDownIcon className="w-6 h-6 text-red-500" data-id="element-155" />,
    text: 'Sabes que puede llegar lejos pero un error lo hunde y le destruye la confianza'
  }, {
    icon: <AlertCircleIcon className="w-6 h-6 text-red-500" data-id="element-156" />,
    text: 'No sabes cómo acompañarlo sin presionarlo más o empeorar lo que siente'
  }, {
    icon: <HomeIcon className="w-6 h-6 text-red-500" data-id="element-157" />,
    text: 'La presión del fútbol ya se siente también en casa antes y después de cada partido'
  }, {
    icon: <HeartCrackIcon className="w-6 h-6 text-red-500" data-id="element-158" />,
    text: 'Quieres que vuelva a disfrutar, que mejore su rendimiento y se fortalezca mentalmente dentro y fuera del campo'
  }];
  return <section className="py-20 md:py-28 bg-white" data-id="element-159">
      <div className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-161">
          <h2 className="md:text-4xl font-heading text-brand-slate text-[35px]" data-id="element-162">
            Este producto es para ti si...
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-163">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex items-start p-5 md:p-6 bg-white rounded-2xl border border-gray-100" data-id="element-164">
              <div className="flex-shrink-0 mr-4 mt-0.5 p-2.5 rounded-xl bg-[#FFEDED]" data-id="element-165">
                {point.icon}
              </div>
              <p className="text-base md:text-lg text-brand-slate-light leading-relaxed" data-id="element-166">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}